export default "__VITE_ASSET__b6b0cbf1__"